<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { getLang } from '@/util/lang'
export default {
  name: 'App',
  created() {
    const lang = getLang()
    let lang4set = lang ? lang : 'es'
    this.$i18n.locale = lang4set
    this.$Local(lang4set)
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
.href-type {
  color: #0066FF;
}
.column-title {
  text-align: right;
  padding-right: 5px;
}
.column-content {
  text-align: left;
  padding-left: 5px;
}
.common-text {
  font-size: 14px;
  color: #646566;
}
.link-type {
  font-size: 14px;
  color: #0066FF;
}
</style>
